import { get } from "lodash";
import { rem } from "polished";
import styled from "styled-components";

const CardContent = styled.div.attrs({
  "data-testid": "card-content",
})`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  padding: ${rem(24)};
  position: relative;
`;

CardContent.Title = styled.h1.attrs({
  "data-testid": "card-title",
})`
  color: ${(props) => get(props, "theme.palette.base.dark")};
  font-size: ${rem(20)};
  line-height: ${26 / 20};
  margin-bottom: ${rem(16)};
`;

CardContent.SubTitle = styled.h2.attrs({
  "data-testid": "card-title",
})`
  color: rgba(42, 63, 83, 0.4);
  font-size: ${rem(16)};
  font-family: PublicSans-Regular;
  line-height: ${26 / 20};
  margin-top: 0px;
  margin-bottom: ${rem(8)};
`;

CardContent.Body = styled.div.attrs({
  "data-testid": "card-body",
})`
  flex: 1;
  font-size: ${rem(14)};
  line-height: ${18 / 14};

  strong {
    font-family: PublicSans-SemiBold;
  }

  > :last-child {
    margin-bottom: 0;
  }
`;

export default CardContent;
